module.exports = __webpack_public_path__ + "static/media/arrow-thin.66be2850.svg";